<page-account-settings></page-account-settings>
<page-account-information></page-account-information>
<page-account-help></page-account-help>
@if (_responsive.$isTablet()) {
  <div class="h-12"></div>
  <button class="tertiary w-[132px] self-center" (click)="logout()" data-what="logout-button">
    <ng-icon name="matLogoutRound" />
    {{ 'logout' | transloco }}
  </button>
}
